import { defineAbility } from '@casl/ability';

const user = JSON.parse(localStorage.getItem('user')) || {};
const roles = user.roles || [];

function hasRole(roles, role) {
  return roles.findIndex(r => r === role) !== -1;
}

export default defineAbility((can, cannot) => {
  if (hasRole(roles, 'ROLE_ADMIN_SUPPER')) {
    can('manage', 'AdminUser');
  } else {
    cannot('manage', 'AdminUser');
  }
});



// function subjectName(item) {
//   if (!item || typeof item === 'string') {
//     return item
//   }
//
//   return item.__type
// }
//
// export default AbilityBuilder.define({ subjectName }, can => {
//   can(['read', 'create'], 'Todo')
//   can(['update', 'delete'], 'Todo', { assignee: 'me' })
// })
